import styled from 'styled-components';
import { colors } from 'theme';

export const RequestCardLayout = styled.section`
    padding: 16px 24px;
    border-radius: 6px;
    background: ${colors.white};
`;

export const RequestCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    min-height: 32px;
`;

export const RequestCardTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    min-width: 0;
`;

export const RequestCardBody = styled.div`
    margin-top: 16px;
    border-top: 1px solid var(--gray-4);
`;

export const CardDetailsToggle = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    padding: 0;
    border: 0;
    background: none;
    color: var(--gray-9);
    cursor: pointer;

    &:hover {
        color: var(--brand-6);
    }
`;

export const ReferralRowLayout = styled.div`
    display: grid;
    grid-template-columns: auto auto auto auto 1fr auto;
    gap: 16px;
    align-items: center;
    padding: 10px 8px;
`;

export const ReferralReference = styled.span<{ $isEditable: boolean }>`
    font-weight: ${({ $isEditable }) => ($isEditable ? 500 : 400)};
    color: ${({ $isEditable }) => ($isEditable ? 'var(--gray-10)' : 'var(--gray-7)')};
`;

export const PageHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
`;

export const CustomsRequestsLayout = styled.div`
    width: 100%;
`;

export const DrawerTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 500;
`;

export const DrawerActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FileNameLink = styled.button`
    padding: 0;
    border: 0;
    background: none;
    color: var(--brand-6);
    text-decoration: underline;
    text-align: left;
    word-break: break-word;
    cursor: pointer;

    &:hover {
        color: var(--brand-5);
    }
`;
